import type {Context} from '../types';

export default (context: Context) => {
  const {
    node: {jsonNode},
  } = context;
  const {data = {}} = jsonNode;

  const isFormButton = jsonNode.type === 'FormButton';
  const hasFormWait = data.form?.wait !== undefined;

  return {
    needed: isFormButton && hasFormWait,
    logData: {
      msg: 'Remove form.wait field from FormButton',
      meta: {
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      // eslint-disable-next-line webflow/no-delete
      delete data.form.wait;
    },
  };
};
